import { render, staticRenderFns } from "./CustomUeditor.vue?vue&type=template&id=264d3d9c"
import script from "./CustomUeditor.vue?vue&type=script&lang=js"
export * from "./CustomUeditor.vue?vue&type=script&lang=js"
import style0 from "./CustomUeditor.vue?vue&type=style&index=0&id=264d3d9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports